<template>
  <div>
    <LoadingSpinner :loading="loading" />

    <div v-if="!loading" class="table-responsive">
      <table
        stickycolumn="true"
        role="table"
        class="
          washup-table
          table
          b-table
          table-bordered
          text-center
          table-hover
          align-middle
        "
      >
        <thead role="rowgroup" class="text-center">
          <tr role="row">
            <th class="empty position-relative p-0">
              <span class="text-competencies" v-text="$lang.exercises" />
              <svg height="100%" width="100%">
                <line
                  x1="0"
                  y1="100%"
                  x2="100%"
                  y2="0"
                  style="stroke: rgb(178 186 193); stroke-width: 2"
                />
              </svg>
              <span class="text-exercises" v-text="$lang.indicators" />
            </th>
            <th
              class="text-center align-middle"
              v-for="(exercise, exerciseIndex) in exercises"
              :key="exerciseIndex"
              role="columnheader"
              scope="col"
            >
              <strong
                class="text-darkslateblue"
                v-text="pathOr('', ['caption'], exercise)"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(indicator, indicatorIndex) in indicators"
            :key="indicatorIndex"
          >
            <td class="text-left text-dark d-flex align-items-center">
              <i
                v-if="pathOr(false, ['value'], indicator) === 1"
                class="fa fa-plus text-success"
              />
              <i v-else class="fa fa-minus text-danger" />
              <span class="ml-2" v-text="pathOr('', ['caption'], indicator)" />
            </td>
            <template v-for="(rowItem, rowIndex) in indicator.exercises">
              <td :key="rowIndex" class="align-middle" v-if="rowItem.selected">
                <i class="fas fa-check-circle fa-lg text-success" />
              </td>
              <td :key="rowIndex" v-else class="align-middle" />
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { setUniqueArrayOfObjects } from "@/shared/utils";

export default {
  name: "exercise-competency-selector-component",
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      loading: false,
      exercises: [],
      indicators: [],
      items: [],
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    showPermissionButton: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getData();
  },
  methods: {
    pathOr,
    setUniqueArrayOfObjects,
    async getData() {
      try {
        this.loading = true;
        const response = await this.$httpService.get(this.url);
        this.items = pathOr([], ["data", "data"], response);
        for (const item of this.items) {
          const { exercises, ...indicator } = item;
          this.exercises = [...this.exercises, ...exercises];
          this.indicators = [...this.indicators, { ...item }];
        }
        this.exercises = setUniqueArrayOfObjects(this.exercises, "id");
        this.indicators = setUniqueArrayOfObjects(this.indicators, "id");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.text-line-left {
  position: absolute;
  left: 0;
  top: 0;
}

.line {
  position: relative;

  &:after {
    position: absolute;
    content: "";
    width: 2px;
    height: 60px;
    background: lightgrey;
    left: 0;
    top: -19px;
    transform: rotate(45deg);
  }
}

.d-content {
  display: contents;
}

.btn-red {
  background: black;
  padding: 2px;
  color: white;
}

.btn-darkslateblue {
  background: darkslateblue;
  padding: 2px;
  color: white;
}

.text-darkslateblue {
  color: darkslateblue;
}

.text-competencies {
  position: absolute;
  top: 5%;
  left: 5%;
}

.text-exercises {
  position: absolute;
  right: 5%;
  bottom: 5%;
}

.opacity-9 {
  opacity: 0.9;
  background: #607d8b8a !important;
}
</style>
